import { PageContent } from "@/components/layout/MainWindow";
import { PageHeader } from "@/components/layout/PageHeader";
import {
  createFileRoute,
  Outlet,
  redirect,
  useMatches,
} from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/subscription/_subscription",
)({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (context.trialPeriod)
      throw redirect({
        to: "/settings/profile",
      });
  },
  staticData: {
    meta: {
      title: "Abonnement",
    },
  },
});

function RouteComponent() {
  const matches = useMatches();
  const isUsageRoute = useMemo(
    () =>
      matches.some(
        (m) =>
          m.routeId ===
          "/_dashboard/settings/_admin/subscription/_subscription/credit-usage",
      ),
    [matches],
  );

  return (
    <>
      {isUsageRoute ? (
        <Outlet />
      ) : (
        <div className="flex h-full flex-col">
          <PageHeader title="Abonnement" />
          <PageContent className="flex h-full flex-col pt-7">
            <Outlet />
          </PageContent>
        </div>
      )}
    </>
  );
}
